import { Card } from '@trafiflow/shared-ui'
import { Repeat, ThumbsUp, ThumbsDown, Bookmark, Share2, Sparkles } from 'lucide-react'
import { useState } from 'react'

export function Swipe() {
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleSwipe = (direction: 'left' | 'right') => {
    setCurrentIndex((prev) => prev + 1)
    console.log(`Swiped ${direction}`)
  }

  return (
    <div className="p-6 h-full flex flex-col">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-tf-text">Swipe</h1>
        <p className="text-tf-text-muted mt-1">
          Discover ads Tinder-style. Swipe right to save, left to skip.
        </p>
      </div>

      {/* Filters */}
      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {['All', 'E-commerce', 'SaaS', 'Fashion', 'Food', 'Tech', 'Finance'].map(
          (category) => (
            <button
              key={category}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${ category === 'All' ? 'bg-blue-600 text-white' : 'bg-tf-bg-hover text-tf-text-sub hover:bg-tf-bg-hover' }`}
            >
              {category}
            </button>
          )
        )}
      </div>

      {/* Swipe Card Container */}
      <div className="flex-1 flex items-center justify-center">
        <div className="relative w-full max-w-md">
          {/* Card Stack Effect */}
          <div className="absolute inset-0 transform translate-x-4 translate-y-4 bg-tf-bg-hover rounded-2xl" />
          <div className="absolute inset-0 transform translate-x-2 translate-y-2 bg-tf-bg-hover rounded-2xl" />

          {/* Main Card */}
          <Card className="relative overflow-hidden rounded-2xl shadow-xl">
            <div className="aspect-[4/5] bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
              <Sparkles className="w-24 h-24 text-white/50" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-tf-bg-hover" />
                <div>
                  <h3 className="font-semibold text-tf-text">Brand Name</h3>
                  <p className="text-sm text-tf-text-muted">Fashion & Apparel</p>
                </div>
              </div>
              <p className="text-tf-text-sub mb-4">
                Discover the latest collection with exclusive offers. Limited time only!
              </p>
              <div className="flex items-center gap-4 text-sm text-tf-text-muted">
                <span className="px-2 py-1 bg-tf-bg-hover rounded">Instagram</span>
                <span>1.2M impressions</span>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-center gap-6 py-6">
        <button
          onClick={() => handleSwipe('left')}
          className="w-16 h-16 rounded-full bg-red-100 hover:bg-red-200 flex items-center justify-center transition-colors group"
        >
          <ThumbsDown className="w-7 h-7 text-red-500 group-hover:scale-110 transition-transform" />
        </button>
        <button className="w-12 h-12 rounded-full bg-tf-bg-hover hover:bg-tf-bg-hover flex items-center justify-center transition-colors">
          <Repeat className="w-5 h-5 text-tf-text-muted" />
        </button>
        <button className="w-12 h-12 rounded-full bg-blue-100 hover:bg-blue-200 flex items-center justify-center transition-colors">
          <Bookmark className="w-5 h-5 text-blue-500" />
        </button>
        <button
          onClick={() => handleSwipe('right')}
          className="w-16 h-16 rounded-full bg-green-100 hover:bg-green-200 flex items-center justify-center transition-colors group"
        >
          <ThumbsUp className="w-7 h-7 text-green-500 group-hover:scale-110 transition-transform" />
        </button>
        <button className="w-12 h-12 rounded-full bg-primary/15 hover:bg-primary/20 flex items-center justify-center transition-colors">
          <Share2 className="w-5 h-5 text-primary" />
        </button>
      </div>

      {/* Progress */}
      <div className="text-center text-sm text-tf-text-muted">
        {currentIndex + 1} of 50 ads today
      </div>
    </div>
  )
}

export default Swipe
